module.exports = __webpack_public_path__ + "static/media/NU.a3289ebc.jpg";